import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, HostListener } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { SimpleNotificationsComponent, NotificationsService, NotificationType } from 'angular2-notifications';
import { NotificationsConfigModule } from 'app/notification/notification.module'; // Adjust the path as necessary
import { ConfigService } from './services/config.service';
import { TranslocoService } from '@ngneat/transloco';
import { environment } from 'environments/environment';
import { DrakeSharedService } from './services/drake-shared.service';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from './layout/common/notification-dialog/notification-dialog.component';
import { NotificationsService as CustomNotificationsService } from './layout/common/notifications/notifications.service';
import { FirebaseMessagingService } from './services/firebase-messaging-service';
import { DrakeFreeFormComponent } from "../app/drake-components/drake-free-form/drake-free-form.component"

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, DialogModule, NotificationsConfigModule, CommonModule, MonacoEditorModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
    options = {
        position: ['bottom', 'right'],
        timeOut: 3000,
        lastOnBottom: true,
    };
    constructor(
        private notificationsService: NotificationsService,
        private drakeShared: DrakeSharedService,
        private configService: ConfigService,
        private _translocoService: TranslocoService,
        private _dialog: MatDialog,
        private _changeDetectorRef: ChangeDetectorRef,
        private _notificationsService: CustomNotificationsService,
        private firebaseMessaging: FirebaseMessagingService,
        private router: Router) {
        setInterval(() => {

            while (drakeShared.notificationQueue.length) {
                var n = drakeShared.notificationQueue.shift();
                if (n.notification)
                    this.createNotification(n.notificationType, n.message, n.title, n.notification);
                else
                    this.createNotification(n.notificationType, n.message, n.title);


            }
        }, 1000);
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                if (history.state.resetBreadcrumb)
                    this.drakeShared.resetBreadcrumbs();
            }
        })
        drakeShared.requestSubject.subscribe((item: any) => {
            _dialog.open(DrakeFreeFormComponent, {
                width: '600px',
                data: item

            });

        })

    }
    @HostListener('window:message', ['$event'])
    onMessage(event: MessageEvent) {

        const data = event.data;

        if (data?.type === 'NAVIGATE') {

            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigateByUrl(data?.url);
            });

        }
    }

    createNotification(type: 'success' | 'error', title: string, content: string, notification: any = null) {
        const notificationType: NotificationType = type as NotificationType;
        var notificationCreated = this.notificationsService.create(title, content, notificationType);

        if (notification) {
            notificationCreated.click.subscribe((event) => {
                const dialogRef = this._dialog.open(NotificationDialogComponent, {
                    width: '600px',
                    data: { notification }

                });
                notification.Read = true;

                this._notificationsService.update(notification._id, notification).subscribe(() => {
                    this._notificationsService.unreadCount = this._notificationsService.allNotifications.flat().filter(n => !n.Read).length;
                    this._changeDetectorRef.markForCheck();
                });

                dialogRef.afterClosed().subscribe(() => {
                    console.log('Dialog chiuso');

                });
            })
        }
        else {
            return;
        }
    }

}
